export default __webpack_public_path__ + "static/media/rental-contract-generator.246422f0.png";